import React, { useLayoutEffect, useState } from 'react';
import { Flex } from 'antd';
import PageWrapper from 'components/Base/PageWrapper';
import ChartCard from 'components/Shared/ChartCard/ChartCard';
import {
  useGetBannerReportQuery,
  useGetChartsQuery,
} from 'redux/apiSlice/reporting.slice';
import ReportCard from 'components/Shared/ReportCard/ReportCard';
import { useIsFeatureEnabled } from 'hooks/useIsFeatureEnabled';
import { SummaryBar } from './components/SummaryBar/SummaryBar';
import { ChatBot } from './components/ChatBot';
import { ChatBotCard } from './components/ChatBotCard';
import { CardWrapper, ScrollableContainer } from './Reporting.styles';

export const ReportingPage = () => {
  // Fetch charts data using the RTK Query hook
  const { data: charts } = useGetChartsQuery();
  const { data: summaryData } = useGetBannerReportQuery();

  // Check if AI support feature is enabled
  const isAiSupportEnabled = useIsFeatureEnabled('ai_support');

  // Manage chatbot open/close state
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);

  // Filter out hidden charts
  const visibleCharts = charts?.filter(chart => !chart.hidden);

  useLayoutEffect(() => {
    // scroll to top of the page, on first render
    window.scrollTo(0, 0);
  }, []);

  const handleOpenChat = () => {
    setIsChatbotOpen(true);
  };

  const handleCloseChat = () => {
    setIsChatbotOpen(false);
  };

  return (
    <PageWrapper title="Reporting">
      <>
        <SummaryBar data={summaryData} />

        <ScrollableContainer>
          <Flex wrap="wrap" gap={24}>
            {visibleCharts?.map(chart => (
              <CardWrapper key={chart.id}>
                {chart.type === 'svg_chart' ? (
                  <ChartCard {...chart} />
                ) : (
                  <ReportCard {...chart} name="Prepared Reports" />
                )}
              </CardWrapper>
            ))}

            {/* ChatBot Card - only show if AI support is enabled */}
            {isAiSupportEnabled && (
              <CardWrapper>
                <ChatBotCard onOpenChat={handleOpenChat} />
              </CardWrapper>
            )}
          </Flex>
        </ScrollableContainer>

        {/* Chatbot Component - only show if AI support is enabled */}
        {isAiSupportEnabled && (
          <ChatBot isOpen={isChatbotOpen} onClose={handleCloseChat} />
        )}
      </>
    </PageWrapper>
  );
};
